import 'semantic-ui-css/semantic.min.css';
import './cover.css';

import React, { useContext, useState } from 'react';
import { GlobalStateContext } from './GlobalState';
import SqueezeMain from './SqueezeMain';
import StepNavigation from './StepNavigation';

import Home from './Home';
import Builder from './Builder';
import Chat from './Chat';
import FeelLuckyView from './FeelLuckyView';
import SearchView from './SearchView';
import PlaylistTableView from './PlaylistTableView';
import Player from './Player';
import PlaylistSave from './PlaylistSave';

import { BrowserRouter as Router, Routes, Route, useLocation, Link } from 'react-router-dom';

function App() {


  const { globalList } = useContext(GlobalStateContext);

  return (
    <Router>
      <Routes>
        <Route path="*" element={<MainLayout />} />
      </Routes>
    </Router>
  );
}

const MainLayout = () => {
  const location = useLocation();
  const { globalList } = useContext(GlobalStateContext);
  const { showGuide, setShowGuide } = useContext(GlobalStateContext);

  const getStepFromPath = (path) => {
    switch (true) {
      case path.startsWith('/builder'): return 0;
      case path.startsWith('/chat'): return 0;
      case path.startsWith('/mixandsave'): return 1;
      case path.startsWith('/save'): return 2;
      case path.startsWith('/player'): return 3;
      default: return -1;
    }
  };

  const currentStep = getStepFromPath(location.pathname);

  const isActive = (path) => location.pathname.startsWith(path) ? 'text-orange' : 'text-white-50';

  return (
    <div className="container d-flex flex-column min-vh-100 bg-black" >
      {<StepNavigation
        currentStep={currentStep}
        showGuide={showGuide}
        setShowGuide={setShowGuide}
      />}

      <div className="container mt-5 pt-5 bg-black" style={{ paddingTop: '180px !important', backgroundColor: '#000000' }}>
        <br /> <br /><br /> <br /> <br />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/fe" element={<Home />} />
          <Route path="/builder" element={<Builder />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/builder/feellucky" element={<FeelLuckyView />} />
          <Route path="/builder/search" element={<SearchView />} />
          <Route path="/builder/playlist" element={<PlaylistTableView />} />
          <Route path="/mixandsave" element={
            globalList.length > 0 ?
              <SqueezeMain /> :
              <div className="text-white">Please load songs first</div>
          } />
          <Route path="/save" element={<PlaylistSave />} />
          <Route path="/player" element={<Player />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </div>

      <footer className="mt-auto text-white-50 p-3">
        <div className="container">
          <div className="row mb-3 justify-content-center">
            <div className="col-3 text-center">
              <a href="/features" className="text-decoration-none d-block">
                <i className={`bi bi-grid-3x3-gap-fill ${isActive('/features')}`} style={{ fontSize: '2rem' }}></i>
                <div className={isActive('/features')}>Features</div>
              </a>
            </div>
            <div className="col-3 text-center">
              <a href="/learn" className="text-decoration-none d-block">
                <i className={`bi bi-book-fill ${isActive('/learn')}`} style={{ fontSize: '2rem' }}></i>
                <div className={isActive('/learn')}>Learn</div>
              </a>
            </div>
            <div className="col-3 text-center">
              <a href="/blog" className="text-decoration-none d-block">
                <i className={`bi bi-journal-text ${isActive('/blog')}`} style={{ fontSize: '2rem' }}></i>
                <div className={isActive('/blog')}>Blog</div>
              </a>
            </div>
            <div className="col-3 text-center">
              <a href="/about" className="text-decoration-none d-block">
                <i className={`bi bi-info-circle-fill ${isActive('/about')}`} style={{ fontSize: '2rem' }}></i>
                <div className={isActive('/about')}>About</div>
              </a>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <p className="mb-0">
                Song2run.com is Copyright © 2024. All Rights Reserved. Song2run.com uses the Spotify Platform API to display content copyrighted by external entities. Song2run.com is not associated with Spotify, Apple, or Apple Music. By using this site, you agree to the <Link to="/enduseragreement.htm" className="text-white">Song2run.com Copyright, Credits, Terms of Use, Privacy Policy, and Cookie Use Policy.</Link>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;




